export const NavListProperty = {
  Links: 'links',
};

export default {
  NavListProperty,
};
